'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';

export default function ContactMeBar() {
  const router = useRouter();
  const [pressed, setPressed] = useState(false);

  const handlePress = () => {
    setPressed(true);
    setTimeout(() => {
      setPressed(false);
      router?.push('/contact-familial');
    }, 300);
  };

  return (
    <div style={{
      padding: 'clamp(8px, 1vh, 10px) clamp(12px, 1.5vw, 20px) clamp(12px, 1.5vh, 14px) clamp(12px, 1.5vw, 20px)',
      flexShrink: 0,
      paddingBottom: 'max(clamp(12px, 1.5vh, 14px), env(safe-area-inset-bottom))',
    }}>
      <button
        onClick={handlePress}
        aria-label="Demander à être appelé par ma famille"
        style={{
          width: '100%',
          minHeight: '72px',
          background: pressed
            ? 'linear-gradient(135deg, #1A2744 0%, #2D3F6B 100%)'
            : 'linear-gradient(135deg, #2D3F6B 0%, #1A2744 100%)',
          borderRadius: '14px',
          border: '2px solid rgba(93,187,31,0.4)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          transform: pressed ? 'scale(0.99)' : 'scale(1)',
          transition: 'all 0.15s ease',
          boxShadow: '0 2px 16px rgba(26,39,68,0.2)',
        }}
      >
        <div style={{
          width: '44px',
          height: '44px',
          background: 'rgba(93,187,31,0.2)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5DBB1F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </div>
        <span style={{
          color: '#FFFFFF',
          fontSize: 'clamp(18px, 2vw, 24px)',
          fontWeight: 700,
          whiteSpace: 'nowrap',
        }}>
          Demander à être appelé
        </span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  );
}